module.exports = __webpack_public_path__ + "static/media/sample_division_health_bulk_upload.4a7554fb.csv";